<template>
  <span
    class="badge"
    :class="{['badge--' + type]: type}"
  >
    {{ text }}
    <small
      v-if="value"
      class="badge__value"
      v-text="value"
    />
  </span>
</template>

<script>
  export default {
    props: {
      type: {
        type: String,
        default: null
      },
      text: {
        type: String,
        default: "Default badge text"
      },
      value: {
        type: [String, Number],
        default: null
      }
    }
  };
</script>

<style lang="scss">
  @import "../../styles/shared/shared";

  .badge {
    $this: &;
    display: inline-block;
    text-align: center;
    padding: 0.125rem 0.5rem;
    border-radius: 4px;
    vertical-align: middle;
    background-color: $primary;
    color: $white;
    font-weight: 400;
    font-size: $font-size-sm;
    min-width: 5rem;
    &__value {
      display: inline-block;
      vertical-align: middle;
      line-height: $font-size-sm;
      height: $font-size-sm;
      width: $font-size-sm;
      margin-left: .25em;
      background-color: $tangerine;
      font-size: .8em;
      color: $white;
      border-radius: 50%;
    }
    &--accent {
      background-color: $tangerine;
      #{$this}__value {
        background-color: $primary;
      }
    }
  }
</style>
